(ns common.widgets.column-renderers
  (:require ["@mui/material/Chip$default" :as Chip]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Tooltip$default" :as Tooltip]
            ["@mui/material/Typography$default" :as Typography]
            ["moment/min/moment-with-locales$default" :as moment]
            [mate.core :as mc]
            [uix.core :as uix :refer [$ defui]]))

(defui template-dimensions-renderer
  [{:keys [templates-dimensions width supported-dimensions]}]
  (let [chip-width 76 ; width of a chip with dimensions 1920x1080
        spacing 1
        spacing-width (* spacing 8)
        fitting-chips (js/Math.floor (/ width (+ chip-width spacing-width)))]
    ($ Stack
       {:direction "row"
        :alignItems "center"
        :spacing spacing}
       (for [[index template-revision] (mc/seq-indexed (take fitting-chips templates-dimensions))
             :let [{:keys [width height]} template-revision
                   ;; Optionally we can pass :supported-dimensions to show a warning when
                   ;; a dimensions combination is not supported.
                   unsupported-dimensions? (and (some? supported-dimensions)
                                                (not (contains? supported-dimensions template-revision)))]
             :when (and (some? width) (some? height))]
         ($ Tooltip
            {:key index
             :title "This content variant will not be used, as a template
                     with these dimensions hasn't been added to your adset yet."
             :disableHoverListener (not unsupported-dimensions?)}
            ($ Chip
               (cond-> {:label (str width "x" height)}
                 unsupported-dimensions? (assoc :variant "subtle"
                                                :color "warning")))))

       (let [not-rendered-chips (- (count templates-dimensions) fitting-chips)]
         (when (pos? not-rendered-chips)
           ($ Typography
              {:no-wrap true}
              "+ " not-rendered-chips))))))

(defn template-duration-renderer
  [seconds]
  (letfn [(format-duration [^js duration]
            (-> (.asMilliseconds duration)
                (moment/utc)
                (.format "m:ss")))]
    (some-> seconds
            (moment/duration "seconds")
            format-duration)))
